import React from 'react';
import { Button, Icon } from '@chakra-ui/react';
import { FiSave, FiCheck } from 'react-icons/fi';

export default function SaveButton({ 
  onClick, 
  variant = 'primary',
  size = 'md',
  isLoading = false,
  loadingText = 'Kaydediliyor...',
  children = 'Kaydet',
  icon = true,
  ...props 
}) {
  const variants = {
    primary: {
      background: 'linear-gradient(135deg, var(--success-500), var(--success-600))',
      color: 'white',
      _hover: {
        background: 'linear-gradient(135deg, var(--success-600), var(--success-700))',
        transform: 'translateY(-2px)',
        boxShadow: 'var(--shadow-lg)'
      },
      _active: {
        transform: 'translateY(0px)',
        boxShadow: 'var(--shadow-md)'
      }
    },
    secondary: {
      background: 'linear-gradient(135deg, var(--primary-500), var(--primary-600))',
      color: 'white',
      _hover: {
        background: 'linear-gradient(135deg, var(--primary-600), var(--primary-700))',
        transform: 'translateY(-2px)',
        boxShadow: 'var(--shadow-lg)'
      }
    },
    outline: {
      background: 'transparent',
      border: '2px solid var(--success-500)',
      color: 'var(--success-600)',
      _hover: {
        background: 'var(--success-50)',
        transform: 'translateY(-2px)',
        boxShadow: 'var(--shadow-md)'
      }
    },
    glass: {
      background: 'rgba(34, 197, 94, 0.1)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(34, 197, 94, 0.2)',
      color: 'var(--success-700)',
      _hover: {
        background: 'rgba(34, 197, 94, 0.2)',
        transform: 'translateY(-2px)',
        boxShadow: 'var(--shadow-glass)'
      }
    }
  };

  const sizeMap = {
    sm: { fontSize: '0.875rem', px: 4, py: 2, h: '32px' },
    md: { fontSize: '0.875rem', px: 6, py: 3, h: '40px' },
    lg: { fontSize: '1rem', px: 8, py: 4, h: '48px' }
  };

  const currentVariant = variants[variant] || variants.primary;
  const currentSize = sizeMap[size] || sizeMap.md;

  return (
    <Button
      {...currentVariant}
      {...currentSize}
      onClick={onClick}
      isLoading={isLoading}
      loadingText={loadingText}
      fontWeight="600"
      borderRadius="var(--radius-lg)"
      transition="all var(--transition-base)"
      position="relative"
      overflow="hidden"
      leftIcon={icon && !isLoading ? <Icon as={FiSave} /> : undefined}
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-100%',
        width: '100%',
        height: '100%',
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
        transition: 'left 0.5s ease',
      }}
      _hover={{
        ...currentVariant._hover,
        _before: {
          left: '100%'
        }
      }}
      {...props}
    >
      {children}
    </Button>
  )
}
